<template>
  <ComponentCard title="Hadith" icon="solar:document-text-linear">
    <template #actions>
      <form v-if="!readOnly" class="ml-auto flex items-center gap-1" @submit.prevent="find">
        <input v-model="query" type="text" placeholder="Search hadiths" aria-label="Search hadiths" class="w-36 rounded-lg border border-[#1c4848]/10 px-2 py-1 text-xs text-[#1c4848] outline-none focus:border-[#1c4848]/30">
        <button type="submit" class="rounded-lg bg-[#1c4848] px-2.5 py-1 text-[11px] font-bold text-white disabled:opacity-50" :disabled="busy || !query.trim()">{{ busy ? '…' : 'Find' }}</button>
      </form>
    </template>
    <p v-if="error" role="alert" class="text-xs text-red-700">{{ error }}</p>
    <ul v-if="results.length" class="mb-2 space-y-1 rounded-xl bg-[#1c4848]/[0.04] p-1">
      <li v-for="row in results" :key="row.id">
        <button type="button" class="w-full rounded-lg px-3 py-2 text-left hover:bg-white" @click="pick(row)">
          <span class="line-clamp-2 block text-xs leading-snug text-[#1c4848]">{{ row.text }}</span>
          <span v-if="row.source" class="mt-0.5 block text-[10px] font-semibold text-[#a0833c]">{{ row.source }}</span>
        </button>
      </li>
    </ul>
    <BlockField :model-value="attrs.narrator" placeholder="Narrator" :read-only="readOnly" input-class="text-xs italic text-[#1c4848]/70" @update:model-value="set({ narrator: $event })" />
    <BlockField :model-value="attrs.arabic" arabic placeholder="نص الحديث" :read-only="readOnly" input-class="text-[#1c4848]" @update:model-value="set({ arabic: $event })" />
    <BlockField :model-value="attrs.text" placeholder="Text of the hadith" :read-only="readOnly" input-class="text-[15px] leading-relaxed text-[#1c4848]" @update:model-value="set({ text: $event })" />
    <BlockField :model-value="attrs.source" placeholder="Source, like Bukhari 1" :read-only="readOnly" input-class="text-xs font-semibold text-[#a0833c]" @update:model-value="set({ source: $event })" />
  </ComponentCard>
</template>

<script setup>
import { ref } from 'vue';
import BlockField from '@/components/writer/views/BlockField.vue';
import ComponentCard from '@/components/writer/views/ComponentCard.vue';

const props = defineProps({ attrs: Object, readOnly: Boolean, context: Object, set: Function, kind: String });

const query = ref('');
const results = ref([]);
const busy = ref(false);
const error = ref('');

async function find() {
  busy.value = true;
  error.value = '';
  try {
    results.value = await props.context.search({ q: query.value.trim(), kind: 'hadith', limit: 5 });
    if (!results.value.length) error.value = 'No hadith found in this book\'s language.';
  } catch {
    error.value = 'The search failed. Try again.';
  } finally {
    busy.value = false;
  }
}

function pick(row) {
  props.set({ arabic: row.arabic ?? '', text: row.text ?? '', source: row.source ?? '' });
  results.value = [];
  query.value = '';
}
</script>
